module.exports = "pegasus_template/assets/email1-column-11.png";